/**
 * Plain-language summary of a force-refresh response (`POST /projects/:id/dashboard/refresh`,
 * `data.results[] = { tileId, wrote, skippedReason? }`).
 */
const SKIP_REASON_TEXT = {
  NOT_DUE: 'not due yet',
  APPROVAL_STALE: 'approval needs re-review',
  NOT_APPROVED: 'awaiting approval',
  STAGE_NOT_REACHED: 'stage not reached yet',
  NOT_WIRED: 'not connected yet',
  MISSING_REQUIRED_INPUT: 'needs more data',
  INPUT_BUILD_FAILED: 'inputs could not be prepared',
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** @returns {{ refreshed: number, skipped: number, text: string, level: 'success'|'info' }} */
export function summariseRefreshResults(results) {
  const list = Array.isArray(results) ? results.filter((r) => r && r.tileId) : [];
  const refreshed = list.filter((r) => r.wrote === true).length;
  const skippedRows = list.filter((r) => r.wrote !== true);
  if (!list.length) return { refreshed: 0, skipped: 0, text: 'Dashboard refreshed.', level: 'success' };

  const byReason = new Map();
  skippedRows.forEach((r) => {
    const text = SKIP_REASON_TEXT[r.skippedReason] || 'not refreshed';
    byReason.set(text, (byReason.get(text) || 0) + 1);
  });
  const head = `${plural(refreshed, 'tile', 'tiles')} refreshed`;
  if (!skippedRows.length) return { refreshed, skipped: 0, text: `${head}.`, level: 'success' };
  const detail = [...byReason.entries()].map(([text, n]) => `${n} ${text}`).join(', ');
  return {
    refreshed,
    skipped: skippedRows.length,
    text: `${head}, ${skippedRows.length} skipped: ${detail}.`,
    level: refreshed > 0 ? 'success' : 'info',
  };
}
